// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/icons/chevron-down-fill.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-table-styles_page__5s03O {
    margin-top: var(--container-margin);
}

.comparison-table-styles_container__-3eAy {
    width: var(--container-width);
    padding: 0 var(--container-padding);
    margin: 0 auto 0;
    position: relative;
    max-width: calc(100% - 60px);
}

.comparison-table-styles_hightlightedWrapperDefault__trFOx {
    position: relative;
}

.comparison-table-styles_hightlightedWrapperDefault__trFOx p {
    margin: 0 0 31px;
}

.comparison-table-styles_hightlightedWrapperDefault__trFOx::before {
    content: '';
    display: block;
    position: absolute;
    top: -13px;
    left: 0;
    width: 100%;
    height: calc(100% + 13px);
    background: #f3f3f3;
    opacity: 0;
    transition: opacity 0.4s;
}

.comparison-table-styles_activeWrapper__vEHsv::before {
    opacity: 1;
}

.comparison-table-styles_activeWrapper__vEHsv .comparison-table-styles_nav__NPTVY {
    background: #f3f3f3;
}

.comparison-table-styles_activeWrapper__vEHsv table thead th {
    background: #f3f3f3 !important;
}

.comparison-table-styles_activeWrapper__vEHsv .comparison-table-styles_title__\\+v4pG {
    background: #f3f3f3;
}

.comparison-table-styles_hightlightedWrapperDefault__trFOx .comparison-table-styles_tableWrapper__5OQsS > div > table > tbody > tr > td:first-child,
.comparison-table-styles_hightlightedWrapperDefault__trFOx .comparison-table-styles_tableWrapper__5OQsS table thead th:first-child {
    /*background: #f3f3f3;*/
    background-color: var(--white-active);
    /*z-index: 120;*/
}

.comparison-table-styles_sectionWrapper__9r-VK {
    position: relative;
    max-height: calc(100vh - 200px);
    overflow: hidden;
    margin: 0 -60px;
    padding: 0 60px;
}

.comparison-table-styles_tableScrolling__bLzVL {
    max-height: calc(100vh - 350px);
}

.comparison-table-styles_backBtn__AdK-8 {
    text-align: center;
    margin: auto 0;
    /*padding: 20px 0 60px;*/
}

.comparison-table-styles_comparisonPageHeader__euGbR {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--container-margin);
}

.comparison-table-styles_comparisonPageHeader__euGbR button {
    background: transparent;
    color: var(--primary-color);
}

.comparison-table-styles_comparisonPageHeader__euGbR button:hover {
    color: #fff;
    background-color: var(--primary-color-active);
}

.comparison-table-styles_title__\\+v4pG {
    border-bottom: 1px solid var(--light-grey);
    padding-bottom: 6px;
    margin-bottom: 20px;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 20;
    background: var(--white-active);
    transition: background-color 0.4s;
}

.comparison-table-styles_titleLeft__3p\\+kF {
    display: flex;
    align-items: center;
    grid-gap: 10px;
    cursor: pointer;
}

.comparison-table-styles_titleBtns__R8oga {
    display: flex;
    align-items: center;
}

.comparison-table-styles_expand__MswHX {
    height: 28px;
    line-height: 15px;
    padding: 5px 18px;
    margin-right: 20px;
    font-size: 13px;
    font-weight: 300;
    border: 1px solid var(--light-grey);
    background: var(--light-grey);
    color: #7b848e;
    display: flex;
    align-items: center;
}

.comparison-table-styles_expand__MswHX:before {
    content: '';
    display: block;
    width: 12px;
    height: 100%;
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    margin-right: 10px;
    transition: transform 0.4s;
}

.comparison-table-styles_expanded__6Afcq:before {
    transform: rotate(-180deg) translateY(-1px);
}

.comparison-table-styles_collapse__-IRjb {
    padding: 0;
    /*border: 1px solid #7b848e;*/
    background: transparent;
    position: relative;
    color: var(--primary-color-active);
    transition: transform 0.4s;
}

.comparison-table-styles_collapse__-IRjb:hover {
    background: transparent;
    /*border-color: var(--primary-color-active);*/
}

/*.collapse:before,*/
/*.collapse:after {*/
/*    content: '';*/
/*    position: absolute;*/
/*    top: 0;*/
/*    left: 0;*/
/*    right: 0;*/
/*    bottom: 0;*/
/*    width: 16px;*/
/*    height: 1px;*/
/*    margin: auto;*/
/*    background: #7b848e;*/
/*    transition:*/
/*        opacity 0.2s,*/
/*        background-color 0.2s;*/
/*}*/

/*.collapse:after {*/
/*    opacity: 0;*/
/*    transform: rotate(90deg);*/
/*}*/

.comparison-table-styles_collapse__-IRjb.comparison-table-styles_collapsed__RTCKa {
    border-color: #000;
}

.comparison-table-styles_scrollBtn__ItPwS {
    position: absolute;
    top: 29px;
    left: 0;
    background: #f3f3f3;
    border: 0;
    width: 27px;
    padding: 0;
    height: calc(100% - 29px - 40px);
    border-radius: 0;
    z-index: 11;
}

.comparison-table-styles_scrollBtn__ItPwS:hover {
    background: #f3f3f3;
}

.comparison-table-styles_scrollBtnLeft__ajsGH svg {
    transform: rotate(90deg);
}

.comparison-table-styles_scrollBtnRight__lFY3M svg {
    transform: rotate(-90deg);
}

.comparison-table-styles_scrollBtnLeft__ajsGH {
    left: -39px;
}

.comparison-table-styles_scrollBtnRight__lFY3M {
    right: -39px;
    left: auto;
}

.comparison-table-styles_section__-o78t {
    position: relative;
}

.comparison-table-styles_tableOuter__T0I7E table {
    border-collapse: collapse;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: #000;
}

.comparison-table-styles_fadeAnimation__RapFn {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
}

.comparison-table-styles_fadeAnimationActive__r\\+gKk {
    opacity: 1;
    pointer-events: initial;
}

.comparison-table-styles_tableAnimation__HoC-c {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    padding: 0 60px;
    margin: 0 -60px;
    position: relative;
    transition:
        max-height 0.3s,
        opacity 0.3s;
}

.comparison-table-styles_tableAnimationActive__TzIdI {
    max-height: 3000px;
    opacity: 1;
}

.comparison-table-styles_tableOuter__T0I7E {
    /*overflow: auto;*/
    margin-bottom: 40px;
}

.comparison-table-styles_tableOuter__T0I7E > div > table td {
    position: relative;
    z-index: 2;
}

.comparison-table-styles_tableWrapperRow__\\+fDlO table table thead th {
    font-weight: 500;
    opacity: 0.5;
    color: #000;
}

.comparison-table-styles_tableWrapper__5OQsS > div > table {
    table-layout: fixed;
    min-width: 100%;
    margin-bottom: 42px;
}

.comparison-table-styles_tableWrapperRow__\\+fDlO > div > table {
    margin-bottom: 42px;
}

.comparison-table-styles_tableOuter__T0I7E > div > table > tbody > tr {
    position: relative;
}

.comparison-table-styles_tableOuter__T0I7E > div > table > tbody > tr > td:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-bottom: 1px solid var(--light-grey);
    pointer-events: none;
    z-index: 6;
}

.comparison-table-styles_tableWrapperRow__\\+fDlO tr {
    vertical-align: top;
}

.comparison-table-styles_tableWrapperRow__\\+fDlO table {
    width: 100%;
}

.comparison-table-styles_tableWrapperRow__\\+fDlO thead th {
    padding: 0;
    min-width: 150px;
}
.comparison-table-styles_tableWrapperRow__\\+fDlO table table thead th:after {
    display: none;
}

.comparison-table-styles_tableWrapper__5OQsS > div > table > tbody > tr > td:first-child {
    position: sticky;
    left: 0;
    z-index: 8;
    max-width: 150px;
    min-width: 150px;
    width: 150px;
    background: #fbfbfb;
}

/*.tableWrapper > div > table > tbody > tr:first-child > td {*/
/*    z-index: 13;*/
/*    top: 0;*/
/*}*/

.comparison-table-styles_tableWrapper__5OQsS thead th:not(:first-child) {
    position: sticky;
    background: #fbfbfb;
    top: 0;
    /*z-index: 13;*/
}

.comparison-table-styles_tableOuter__T0I7E div > table > thead th {
    position: sticky;
    top: 0;
    background-color: var(--white-active);
    /*z-index: 13;*/
}

th {
    position: relative;
}

div > table > thead th {
    z-index: 12;
}

table thead th {
    padding: 5px 10px;
    position: relative;
    transition: color 0.4s;
}

.comparison-table-styles_tableWrapper__5OQsS table thead th:first-child {
    z-index: 14;
    position: sticky;
    left: 0;
    top: 0;
    background: #fbfbfb;
    transition:
        color 0.4s,
        background-color 0.4s;
}

.comparison-table-styles_sectionWrapper__9r-VK table thead th:after {
    content: '';
    position: absolute;
    display: block;
    width: calc(100% - 20px);
    top: 100%;
    left: 10px;
    border-bottom: 1px solid #7b848e;
    z-index: 12;
    transition: border-color 0.4s;
}

.comparison-table-styles_sectionWrapper__9r-VK table thead th:first-child:after {
    width: calc(100% - 10px);
    left: 0;
}

.comparison-table-styles_sectionWrapper__9r-VK table thead th:last-child:after {
    width: calc(100% - 10px);
}

.comparison-table-styles_tableWrapper__5OQsS > div > table > tbody > tr > td:first-child,
.comparison-table-styles_tableWrapper__5OQsS td {
    padding: 20px 0;
    min-width: 150px;
    font-weight: 400;
}

.comparison-table-styles_tableWrapper__5OQsS > div > table > tbody > tr > td:first-child img {
    margin-top: 10px;
}

.comparison-table-styles_nav__NPTVY {
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    z-index: 6;
    background: var(--white-active);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .comparison-table-styles_tableOuter__T0I7E table {
        font-size: 13px;
    }

    .comparison-table-styles_tableOuter__T0I7E table img {
        max-width: 20px;
    }

    .comparison-table-styles_tableWrapper__5OQsS > div > table > tbody > tr > td:first-child {
        padding: 10px 0;
    }

    .comparison-table-styles_tableOuter__T0I7E td {
        padding: 10px 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ComparisonTable/comparison-table-styles.module.css"],"names":[],"mappings":"AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gFAAuF;IACvF,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB,mBAAmB;AACnB,0BAA0B;AAC1B,cAAc;AACd,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,mBAAmB;AACnB,mBAAmB;AACnB,oBAAoB;AACpB,2BAA2B;AAC3B,kBAAkB;AAClB,wBAAwB;AACxB,iCAAiC;AACjC,IAAI;;AAEJ,oBAAoB;AACpB,kBAAkB;AAClB,gCAAgC;AAChC,IAAI;;AAEJ;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB;;oBAEgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA,8DAA8D;AAC9D,mBAAmB;AACnB,cAAc;AACd,IAAI;;AAEJ;IACI,gBAAgB;IAChB,mBAAmB;IACnB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,mBAAmB;IACnB;;6BAEyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,OAAO;AACX;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.page {\n    margin-top: var(--container-margin);\n}\n\n.container {\n    width: var(--container-width);\n    padding: 0 var(--container-padding);\n    margin: 0 auto 0;\n    position: relative;\n    max-width: calc(100% - 60px);\n}\n\n.hightlightedWrapperDefault {\n    position: relative;\n}\n\n.hightlightedWrapperDefault p {\n    margin: 0 0 31px;\n}\n\n.hightlightedWrapperDefault::before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -13px;\n    left: 0;\n    width: 100%;\n    height: calc(100% + 13px);\n    background: #f3f3f3;\n    opacity: 0;\n    transition: opacity 0.4s;\n}\n\n.activeWrapper::before {\n    opacity: 1;\n}\n\n.activeWrapper .nav {\n    background: #f3f3f3;\n}\n\n.activeWrapper table thead th {\n    background: #f3f3f3 !important;\n}\n\n.activeWrapper .title {\n    background: #f3f3f3;\n}\n\n.hightlightedWrapperDefault .tableWrapper > div > table > tbody > tr > td:first-child,\n.hightlightedWrapperDefault .tableWrapper table thead th:first-child {\n    /*background: #f3f3f3;*/\n    background-color: var(--white-active);\n    /*z-index: 120;*/\n}\n\n.sectionWrapper {\n    position: relative;\n    max-height: calc(100vh - 200px);\n    overflow: hidden;\n    margin: 0 -60px;\n    padding: 0 60px;\n}\n\n.tableScrolling {\n    max-height: calc(100vh - 350px);\n}\n\n.backBtn {\n    text-align: center;\n    margin: auto 0;\n    /*padding: 20px 0 60px;*/\n}\n\n.comparisonPageHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: var(--container-margin);\n}\n\n.comparisonPageHeader button {\n    background: transparent;\n    color: var(--primary-color);\n}\n\n.comparisonPageHeader button:hover {\n    color: #fff;\n    background-color: var(--primary-color-active);\n}\n\n.title {\n    border-bottom: 1px solid var(--light-grey);\n    padding-bottom: 6px;\n    margin-bottom: 20px;\n    margin-top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n    background: var(--white-active);\n    transition: background-color 0.4s;\n}\n\n.titleLeft {\n    display: flex;\n    align-items: center;\n    grid-gap: 10px;\n    cursor: pointer;\n}\n\n.titleBtns {\n    display: flex;\n    align-items: center;\n}\n\n.expand {\n    height: 28px;\n    line-height: 15px;\n    padding: 5px 18px;\n    margin-right: 20px;\n    font-size: 13px;\n    font-weight: 300;\n    border: 1px solid var(--light-grey);\n    background: var(--light-grey);\n    color: #7b848e;\n    display: flex;\n    align-items: center;\n}\n\n.expand:before {\n    content: '';\n    display: block;\n    width: 12px;\n    height: 100%;\n    background: transparent url('/src/assets/icons/chevron-down-fill.svg') no-repeat center;\n    margin-right: 10px;\n    transition: transform 0.4s;\n}\n\n.expanded:before {\n    transform: rotate(-180deg) translateY(-1px);\n}\n\n.collapse {\n    padding: 0;\n    /*border: 1px solid #7b848e;*/\n    background: transparent;\n    position: relative;\n    color: var(--primary-color-active);\n    transition: transform 0.4s;\n}\n\n.collapse:hover {\n    background: transparent;\n    /*border-color: var(--primary-color-active);*/\n}\n\n/*.collapse:before,*/\n/*.collapse:after {*/\n/*    content: '';*/\n/*    position: absolute;*/\n/*    top: 0;*/\n/*    left: 0;*/\n/*    right: 0;*/\n/*    bottom: 0;*/\n/*    width: 16px;*/\n/*    height: 1px;*/\n/*    margin: auto;*/\n/*    background: #7b848e;*/\n/*    transition:*/\n/*        opacity 0.2s,*/\n/*        background-color 0.2s;*/\n/*}*/\n\n/*.collapse:after {*/\n/*    opacity: 0;*/\n/*    transform: rotate(90deg);*/\n/*}*/\n\n.collapse.collapsed {\n    border-color: #000;\n}\n\n.scrollBtn {\n    position: absolute;\n    top: 29px;\n    left: 0;\n    background: #f3f3f3;\n    border: 0;\n    width: 27px;\n    padding: 0;\n    height: calc(100% - 29px - 40px);\n    border-radius: 0;\n    z-index: 11;\n}\n\n.scrollBtn:hover {\n    background: #f3f3f3;\n}\n\n.scrollBtnLeft svg {\n    transform: rotate(90deg);\n}\n\n.scrollBtnRight svg {\n    transform: rotate(-90deg);\n}\n\n.scrollBtnLeft {\n    left: -39px;\n}\n\n.scrollBtnRight {\n    right: -39px;\n    left: auto;\n}\n\n.section {\n    position: relative;\n}\n\n.tableOuter table {\n    border-collapse: collapse;\n    text-align: center;\n    font-size: 14px;\n    line-height: 18px;\n    color: #000;\n}\n\n.fadeAnimation {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s;\n}\n\n.fadeAnimationActive {\n    opacity: 1;\n    pointer-events: initial;\n}\n\n.tableAnimation {\n    opacity: 0;\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 60px;\n    margin: 0 -60px;\n    position: relative;\n    transition:\n        max-height 0.3s,\n        opacity 0.3s;\n}\n\n.tableAnimationActive {\n    max-height: 3000px;\n    opacity: 1;\n}\n\n.tableOuter {\n    /*overflow: auto;*/\n    margin-bottom: 40px;\n}\n\n.tableOuter > div > table td {\n    position: relative;\n    z-index: 2;\n}\n\n.tableWrapperRow table table thead th {\n    font-weight: 500;\n    opacity: 0.5;\n    color: #000;\n}\n\n.tableWrapper > div > table {\n    table-layout: fixed;\n    min-width: 100%;\n    margin-bottom: 42px;\n}\n\n.tableWrapperRow > div > table {\n    margin-bottom: 42px;\n}\n\n.tableOuter > div > table > tbody > tr {\n    position: relative;\n}\n\n.tableOuter > div > table > tbody > tr > td:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    border-bottom: 1px solid var(--light-grey);\n    pointer-events: none;\n    z-index: 6;\n}\n\n.tableWrapperRow tr {\n    vertical-align: top;\n}\n\n.tableWrapperRow table {\n    width: 100%;\n}\n\n.tableWrapperRow thead th {\n    padding: 0;\n    min-width: 150px;\n}\n.tableWrapperRow table table thead th:after {\n    display: none;\n}\n\n.tableWrapper > div > table > tbody > tr > td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 8;\n    max-width: 150px;\n    min-width: 150px;\n    width: 150px;\n    background: #fbfbfb;\n}\n\n/*.tableWrapper > div > table > tbody > tr:first-child > td {*/\n/*    z-index: 13;*/\n/*    top: 0;*/\n/*}*/\n\n.tableWrapper thead th:not(:first-child) {\n    position: sticky;\n    background: #fbfbfb;\n    top: 0;\n    /*z-index: 13;*/\n}\n\n.tableOuter div > table > thead th {\n    position: sticky;\n    top: 0;\n    background-color: var(--white-active);\n    /*z-index: 13;*/\n}\n\nth {\n    position: relative;\n}\n\ndiv > table > thead th {\n    z-index: 12;\n}\n\ntable thead th {\n    padding: 5px 10px;\n    position: relative;\n    transition: color 0.4s;\n}\n\n.tableWrapper table thead th:first-child {\n    z-index: 14;\n    position: sticky;\n    left: 0;\n    top: 0;\n    background: #fbfbfb;\n    transition:\n        color 0.4s,\n        background-color 0.4s;\n}\n\n.sectionWrapper table thead th:after {\n    content: '';\n    position: absolute;\n    display: block;\n    width: calc(100% - 20px);\n    top: 100%;\n    left: 10px;\n    border-bottom: 1px solid #7b848e;\n    z-index: 12;\n    transition: border-color 0.4s;\n}\n\n.sectionWrapper table thead th:first-child:after {\n    width: calc(100% - 10px);\n    left: 0;\n}\n\n.sectionWrapper table thead th:last-child:after {\n    width: calc(100% - 10px);\n}\n\n.tableWrapper > div > table > tbody > tr > td:first-child,\n.tableWrapper td {\n    padding: 20px 0;\n    min-width: 150px;\n    font-weight: 400;\n}\n\n.tableWrapper > div > table > tbody > tr > td:first-child img {\n    margin-top: 10px;\n}\n\n.nav {\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    font-size: 18px;\n    z-index: 6;\n    background: var(--white-active);\n}\n\n@media screen-md-max {\n    .tableOuter table {\n        font-size: 13px;\n    }\n\n    .tableOuter table img {\n        max-width: 20px;\n    }\n\n    .tableWrapper > div > table > tbody > tr > td:first-child {\n        padding: 10px 0;\n    }\n\n    .tableOuter td {\n        padding: 10px 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"page": `comparison-table-styles_page__5s03O`,
	"container": `comparison-table-styles_container__-3eAy`,
	"hightlightedWrapperDefault": `comparison-table-styles_hightlightedWrapperDefault__trFOx`,
	"activeWrapper": `comparison-table-styles_activeWrapper__vEHsv`,
	"nav": `comparison-table-styles_nav__NPTVY`,
	"title": `comparison-table-styles_title__+v4pG`,
	"tableWrapper": `comparison-table-styles_tableWrapper__5OQsS`,
	"sectionWrapper": `comparison-table-styles_sectionWrapper__9r-VK`,
	"tableScrolling": `comparison-table-styles_tableScrolling__bLzVL`,
	"backBtn": `comparison-table-styles_backBtn__AdK-8`,
	"comparisonPageHeader": `comparison-table-styles_comparisonPageHeader__euGbR`,
	"titleLeft": `comparison-table-styles_titleLeft__3p+kF`,
	"titleBtns": `comparison-table-styles_titleBtns__R8oga`,
	"expand": `comparison-table-styles_expand__MswHX`,
	"expanded": `comparison-table-styles_expanded__6Afcq`,
	"collapse": `comparison-table-styles_collapse__-IRjb`,
	"collapsed": `comparison-table-styles_collapsed__RTCKa`,
	"scrollBtn": `comparison-table-styles_scrollBtn__ItPwS`,
	"scrollBtnLeft": `comparison-table-styles_scrollBtnLeft__ajsGH`,
	"scrollBtnRight": `comparison-table-styles_scrollBtnRight__lFY3M`,
	"section": `comparison-table-styles_section__-o78t`,
	"tableOuter": `comparison-table-styles_tableOuter__T0I7E`,
	"fadeAnimation": `comparison-table-styles_fadeAnimation__RapFn`,
	"fadeAnimationActive": `comparison-table-styles_fadeAnimationActive__r+gKk`,
	"tableAnimation": `comparison-table-styles_tableAnimation__HoC-c`,
	"tableAnimationActive": `comparison-table-styles_tableAnimationActive__TzIdI`,
	"tableWrapperRow": `comparison-table-styles_tableWrapperRow__+fDlO`
};
export default ___CSS_LOADER_EXPORT___;
